import * as d3 from 'd3';
import { useEffect } from "react";


const BarChart = (props) => {

    // binding to properties

    const { data, outerRadius,realWidth, siteText} = props;

    // findmax value of data
    // const max = findMax(data.map(d => d.value));

    let max2;

    // bind draw to -> data change

    useEffect(() => {
        if (!data) return;
        max2 = findMax(data);
        drawChart();
    }, [data, outerRadius,realWidth, max2]);




    const drawChart = () => {
        let margin,width,height=null;
        //sums perday
        let Data = d3.rollup(data, v => d3.sum(v, d => d.amount), ((d) => { return d.date.slice(0, 6) }));
        let cleaData= [];
        Data = Array.from(Data, ([date, amount]) => ({ date, amount }))
        Data = Data.sort((a,b)=>(a.date>b.date)?1:-1)
        Data.forEach((val)=>{
            cleaData.push({date:YearMonthToDateString(val.date),amount:val.amount})
        })

        // constants
        margin=30;
        if(+outerRadius<180){
            width = + 260 - (2 * margin);
        }else{
            width = +outerRadius - (2 * margin);

        }
        if(outerRadius){
            height = 600- (2 * margin);
        }


        // remove old svg
        d3.select('#barchart-container')
            .select('svg')
            .remove();

        // create new svg

        const svg = d3
            .select('#barchart-container')
            .append('svg')
            .attr('width', `100%`)
            .attr('height', `${(height+(2*margin))*0.618}`);

        // initiate elements
        // move postion $margin
        const chart = svg.append('g')
            .attr('transform', `translate(${margin},${margin / 2})`);

        // scaling

        const yScale = d3.scaleLinear()
            .range([height * 0.56, 0])
            .domain([0, max2]);

        // create Y axis

        chart.append('g').call(d3.axisLeft(yScale));

        const xScale = d3.scaleBand()
            .range([0, width])
            .domain(cleaData.map((s) => s.date))
            .padding(0.4);

        chart.append('g')
            .attr('transform', `translate(0,${height * 0.56})`)
            .attr('class', 'bottom-text')
            .call(d3.axisBottom(xScale))
            .selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", "rotate(-55)");


        chart.selectAll()
            .data(cleaData)
            .enter()
            .append('rect')
            .attr('x', (s) => xScale(s.date))
            .attr('y', (s) => yScale(s.amount))
            .attr('height', (s) => {
                return height * 0.56 - yScale(s.amount)
            })
            .attr('width', xScale.bandwidth())
            .style('fill', 'purple');


    };


    // find the highest value to scale the 
    const findMax = (data) => {
        //sums perday
        let summerizeData= d3.rollup(data, v => d3.sum(v, d => d.amount), ((d) => { return d.date.slice(0, 6) }));
        summerizeData= Array.from(summerizeData, ([date, amount]) => ({ date, amount }))
        let max = 0;
        const a = summerizeData.length;

        for (let counter = 0; counter < a; counter++) {
            let item = +summerizeData[counter].amount;
            if (item > max) {
                max = item;
            }
        }
        return max;
    }

    const YearMonthToDateString=(date)=>{
        let year=date.slice(2,4);
        let month_date=date.slice(4,6);
        let month=siteText.homeSummaryMonths[month_date-1]
        return `${month} - ${year}`
    }

    return (
        <div id="barchart-container">
        </div>
    )
}

export default BarChart;